import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContactExpertData } from 'src/app/models/dashboard/dashboard';

@Component({
  selector: 'app-contact-expert',
  templateUrl: './contact-expert.component.html',
  styleUrls: ['./contact-expert.component.scss']
})
export class ContactExpertComponent implements OnInit {

  @Input() contactExpertData: ContactExpertData;
  @Output() contactExpertReqEmit: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  contactExpertReq(){
    this.contactExpertReqEmit.emit();
  }

}
